package floris.graphics.models.domain.models.project

import floris.graphics.models.domain.models.Category
import floris.graphics.models.domain.models.Contributor
import floris.graphics.models.domain.models.MediaFile
import floris.graphics.models.domain.models.Techstack
import floris.graphics.models.domain.models.interfaces.DateAble
import floris.graphics.models.domain.models.toCategory
import floris.graphics.models.domain.models.toContributor
import floris.graphics.models.domain.models.toDto
import floris.graphics.models.domain.models.toMediaFile
import floris.graphics.models.domain.models.toTechstack
import floris.graphics.models.domain.models.user.User
import floris.graphics.models.domain.models.user.toDto
import floris.graphics.models.domain.models.user.toUser
import floris.graphics.models.dto.requests.project.ProjectDetailDto
import org.w3c.dom.url.URL

data class ProjectDetail(
    val id: String = "",
    val user: User = User(),
    val title: String = "",
    val subtitle: String = "",
    val content: String = "",
    val previewVideoMediaFile: MediaFile? = null,
    val thumbnailMediaFile: MediaFile? = null,
    val videoUrl: String = "",
    val categories: List<Category>? = null,
    val techstacks: List<Techstack>? = null,
    val frameMediaFiles: List<MediaFile> = emptyList(),
    override val createdAt: String = "",
    override val updatedAt: String = "",
    val deletedAt: String? = null,
    val client: Contributor? = null,
    val agency: Contributor? = null,
    val design: Contributor? = null,
    val animator: Contributor? = null,
) : DateAble {

    val embeddedVideoUrl: String?
        get() = run {
            if (videoUrl.isEmpty()) return@run null

            return if (videoUrl.contains("vimeo")) {
                val vimeoId = extractVimeoId(videoUrl)
                "http://player.vimeo.com/video/$vimeoId"
            } else {
                val youtubeId = extractYouTubeId(videoUrl)
                "https://www.youtube.com/embed/$youtubeId"
            }
        }

    private fun extractYouTubeId(url: String): String? {
        val pattern = """(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S*\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})""".toRegex()
        val matchResult = pattern.find(url)
        return matchResult?.groups?.get(1)?.value
    }

    private fun extractVimeoId(url: String): String? {
        val pattern = """(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/)([0-9]+)""".toRegex()
        val matchResult = pattern.find(url)
        return matchResult?.groups?.get(1)?.value
    }
}

fun ProjectDetail.toDto() = ProjectDetailDto(
    id = this.id,
    user = this.user.toDto(),
    title = this.title,
    subtitle = this.subtitle,
    content = content,
    categories = categories?.map { it.toDto() },
    techstacks = techstacks?.map { it.toDto() },
    createdAt = createdAt,
    updatedAt = updatedAt,
    deletedAt = deletedAt,
    client = client?.toDto(),
    agency = agency?.toDto(),
    design = design?.toDto(),
    animator = animator?.toDto()
)

fun ProjectDetailDto.toProjectDetail() = ProjectDetail(
    id = this.id,
    user = this.user.toUser(),
    title = this.title,
    subtitle = this.subtitle,
    content = content,
    previewVideoMediaFile = previewVideoMediaFile?.toMediaFile(),
    thumbnailMediaFile = thumbnailMediaFile?.toMediaFile(),
    videoUrl = videoUrl,
    frameMediaFiles = frameMediaFiles.map { it.toMediaFile() },
    categories = categories?.map { it.toCategory() },
    techstacks = techstacks?.map { it.toTechstack() },
    createdAt = createdAt,
    updatedAt = updatedAt,
    deletedAt = deletedAt,
    client = client?.toContributor(),
    agency = agency?.toContributor(),
    design = design?.toContributor(),
    animator = animator?.toContributor()

)